import { app } from "../../config/constants"
import * as CategoriesActions from './actions'
import {store} from "../../reducers";

export const write = ( category ) => {
	return new Promise( ( resolve, reject ) => {
		app.database().ref('/cams/categories').orderByChild('wordpressId').equalTo(category.wordpressId).once('value', (categories) => {
			if (null === categories.val()) {
				app.database().ref('/cams/categories').push(category).then(categorySnap => {
					resolve();
				});
			} else {
				categories.forEach((categorySnap) => {
					resolve();
					app.database().ref('/cams/categories').child(categorySnap.key).set(category).then(categorySnap => {
						resolve();
					});
				});
			}
		});
	} );
};

export const getCategories = () => {
	new Promise( ( resolve, reject ) => {
		let categoriesToReturn = [];
		app.database().ref('/cams/categories').orderByChild('name').once('value', ( categories ) => {
			let j = 0;
			categories.forEach( ( category ) => {
				categoriesToReturn.push({
					name: category.val().name,
					key: category.key,
				});

				if ( ++j === categories.numChildren() ) {
					resolve( categoriesToReturn );
				}



			});
		});
	}).then( ( categories ) => {
		store.dispatch(CategoriesActions.AddCategories(categories));
	})
};

export const get = () => {
	return new Promise( ( resolve, reject ) => {
		let i = 0;
		let categories = [];

		app.database().ref('cams/categories').once( 'value', categoriesSnap => {
			categoriesSnap.forEach( categorySnap => {
				categories.push({
					id: categorySnap.val().term_id,
					label: categorySnap.val().name,
				})

				if ( ++i === categoriesSnap.numChildren() ) {
					resolve( categories );
				}
			});
		})
	});
}


// WEBPACK FOOTER //
// ./src/api/categories/index.js